import stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { FC } from 'react';

export const CodeRow: FC<{ codePart?: string; isError?: boolean }> = ({ codePart, isError = false }) => {
  const chars = codePart ? codePart.split('') : ['', '', ''];

  return (
    <div {...stylex.props(styles.codePart)}>
      {chars.map((char, i) => (
        <span key={i} {...stylex.props(styles.charBlock, isError ? styles.errorBorder : styles.normalBorder)}>
          {char}
        </span>
      ))}
    </div>
  );
};
